import TestimonialCard from "./TestimonialCard";

const DesktopShowcase = ({ testimonials, currentIndex, isTransitioning }) => {
 
  return (
    <div
      className="hidden md:flex md:w-[55%] p-10 flex-col justify-center text-white relative overflow-hidden"
      style={{ backgroundColor: "rgb(18, 61, 108)" }}
    >
      <div
        className="absolute top-0 left-0 w-full h-full animate-clouds z-0 opacity-40 bg-repeat-x"
        style={{
          backgroundImage: `url("${import.meta.env.PUBLIC_CLOUDFRONT_BASE_URL}/assets/clouds_bg.png")`,
          backgroundSize: "cover",
        }}
      />
      <img
        src={`${import.meta.env.PUBLIC_CLOUDFRONT_BASE_URL}/assets/blue-flight.svg`}

        alt="Plane"
        className="w-96 mx-auto mb-48 animate-fly"
      />

      <div className="relative z-10 overflow-hidden w-full">
        <div
          className={`flex ${isTransitioning ? "transition-transform duration-700 ease-in-out" : ""}`}
          style={{ transform: `translateX(-${currentIndex * 100}%)` }}
        >
          {testimonials.map((item, index) => (
            <div key={`${item.name}-${index}`} className="w-full shrink-0">
              <TestimonialCard item={item} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default DesktopShowcase;
